export default "__VITE_ASSET__B1Z_gHnI__"